var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8808_61836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9156 0.733154H4.08434C2.23366 0.733154 0.733398 2.23342 0.733398 4.08409V11.9153C0.733398 13.766 2.23366 15.2663 4.08434 15.2663H11.9156C13.7663 15.2663 15.2665 13.766 15.2665 11.9153V4.08409C15.2665 2.23342 13.7663 0.733154 11.9156 0.733154Z",
    fill: "url(#paint0_linear_8808_61836)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3439 3.60041C10.8956 3.60263 11.4241 3.82278 11.8142 4.21291C12.2043 4.60303 12.4245 5.13151 12.4267 5.68322V10.3163C12.4245 10.8681 12.2043 11.3965 11.8142 11.7867C11.4241 12.1768 10.8956 12.3969 10.3439 12.3992H5.65637C5.10466 12.3969 4.57617 12.1768 4.18605 11.7867C3.79593 11.3965 3.57578 10.8681 3.57355 10.3163V5.68322C3.57578 5.13151 3.79593 4.60303 4.18605 4.21291C4.57617 3.82278 5.10466 3.60263 5.65637 3.60041H10.3439ZM10.3439 2.63166H5.65637C3.97793 2.63166 2.60449 4.00666 2.60449 5.68354V10.3163C2.60449 11.9948 3.97949 13.3682 5.65637 13.3682H10.3439C12.0223 13.3682 13.3957 11.9932 13.3957 10.3163V5.68322C13.3957 4.00479 12.0223 2.63135 10.3439 2.63135V2.63166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99985 6.19141C8.35752 6.19141 8.70716 6.29747 9.00456 6.49618C9.30196 6.6949 9.53375 6.97734 9.67062 7.30778C9.8075 7.63823 9.84331 8.00185 9.77353 8.35265C9.70376 8.70345 9.53152 9.02569 9.2786 9.2786C9.02569 9.53152 8.70346 9.70375 8.35265 9.77353C8.00185 9.84331 7.63823 9.8075 7.30779 9.67062C6.97734 9.53375 6.6949 9.30195 6.49618 9.00456C6.29747 8.70716 6.19141 8.35752 6.19141 7.99984C6.19199 7.52039 6.3827 7.06075 6.72173 6.72172C7.06075 6.3827 7.5204 6.19199 7.99985 6.19141ZM7.99985 5.22266C7.45057 5.22266 6.91363 5.38554 6.45692 5.6907C6.00022 5.99586 5.64426 6.4296 5.43406 6.93706C5.22386 7.44452 5.16886 8.00292 5.27602 8.54165C5.38318 9.08037 5.64768 9.57521 6.03608 9.96361C6.42447 10.352 6.91932 10.6165 7.45804 10.7237C7.99676 10.8308 8.55516 10.7758 9.06263 10.5656C9.57009 10.3554 10.0038 9.99947 10.309 9.54277C10.6142 9.08606 10.777 8.54912 10.777 7.99984C10.777 7.26329 10.4844 6.5569 9.96361 6.03608C9.44279 5.51525 8.7364 5.22266 7.99985 5.22266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8381 5.75926C11.2018 5.75926 11.4966 5.46447 11.4966 5.10082C11.4966 4.73718 11.2018 4.44238 10.8381 4.44238C10.4745 4.44238 10.1797 4.73718 10.1797 5.10082C10.1797 5.46447 10.4745 5.75926 10.8381 5.75926Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8808_61836",
    x1: 10.2584,
    y1: 15.8763,
    x2: 5.74152,
    y2: 0.123154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDAD4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FB832E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FA7321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F6692F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E84A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E03675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#DD2F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#B43D97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4D60D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4264DB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8808_61836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.953741d63db13da9ce4ca64ed50e21fe.svg";
export { ForwardRef as ReactComponent };